import { NotFoundPage } from "popopo-lib-react/simple-pages"
import "../style/simple-pages.scss"

/**
 * 404 Not Found page component.
 * Displayed when a user navigates to a route that doesn't exist.
 */
export const NotFound = () => {
  return (
    <NotFoundPage
      locale="ja"
      homeUrl="/"
    />
  )
}
